import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Nav } from 'react-bootstrap-5';

import Fields from './fields';
import Tasks from './tasks';
import Stages from './stages';
import { isListingPlaybook } from './helpers';

export default function Playbook({ playbook, playbooks, stage, status }) {
  const [selectedTab, setSelectedTab] = useState('fields');

  if (isListingPlaybook(playbook)) {
    return (
      <div className="playbook">
        <Stages playbook={playbook} />
        <Tasks playbook={playbook} playbooks={playbooks} stage={stage} status={status} />
      </div>
    );
  }

  return (
    <div className="playbook">
      <Stages playbook={playbook} />
      <Nav
        activeKey={selectedTab}
        className="mb-5"
        variant="pills"
        onSelect={setSelectedTab}
      >
        <Nav.Item>
          <Nav.Link eventKey="fields">Data Fields</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="tasks">Deal Tasks</Nav.Link>
        </Nav.Item>
      </Nav>
      {selectedTab === 'fields' ?
        <Fields playbook={playbook} stage={stage} /> :
        <Tasks playbook={playbook} playbooks={playbooks} stage={stage} />
      }
      
    </div>
  );
}

Playbook.propTypes = {
  playbook: PropTypes.object.isRequired,
  playbooks: PropTypes.array.isRequired,
  stage: PropTypes.object,
  status: PropTypes.object,
};
